import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@milanote/roma';
import { cx } from '@milanote/roma/utils';

const HoverReveal = ({ children, revealChildren, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLockedOpen, setIsLockedOpen] = useState(false);

    const title = <span className="whitespace-pre-wrap break-words">{revealChildren}</span>;

    const toggleLockedOpen = () => {
        setIsLockedOpen((wasLockedOpen) => {
            const shouldLockOpen = !wasLockedOpen;
            setIsOpen(shouldLockOpen);
            return shouldLockOpen;
        });
    };

    const handleOpenChange = (nextOpen) => {
        if (isLockedOpen) return;

        setIsOpen(nextOpen);
    };

    return (
        <Tooltip title={title} placement="bottom start" delay={300} isOpen={isOpen} onOpenChange={handleOpenChange}>
            <Tooltip.Trigger
                type="button"
                onPress={toggleLockedOpen}
                className={cx(
                    'cursor-pointer appearance-none border-0 border-b border-dotted border-primary bg-transparent p-0 text-left font-inherit text-primary',
                    isLockedOpen && 'border-solid border-black text-black',
                    className,
                )}
            >
                {children}
            </Tooltip.Trigger>
        </Tooltip>
    );
};

HoverReveal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string, PropTypes.number]),
    revealChildren: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
};

export default HoverReveal;
